import classnames from 'classnames';

import styles from './RevealButton.module.css';

import {
  Eye,
  EyeFoundation,
  HiddenEye,
  HiddenEyeFoundation,
} from '../../../icons';
import { visuallyHidden } from '../../../styles';
import type { ButtonBaseProps } from '../../ButtonBase';
import { ButtonBase } from '../../ButtonBase';

export interface RevealButtonProps extends ButtonBaseProps {
  /** Toggle icons to match password visibility state. */
  show: boolean;
}

export function RevealButton(props: RevealButtonProps) {
  const { className, show = 'false', ...buttonBaseProps } = props;
  return (
    <ButtonBase
      className={classnames(styles.button, className)}
      aria-label="Show password"
      role="switch"
      aria-checked={show}
      {...buttonBaseProps}
    >
      <span className={styles.defaultIcon}>
        {show ? (
          <HiddenEye title="Hide password" />
        ) : (
          <Eye title="Show password" />
        )}
      </span>
      <span className={styles.foundationIcon}>
        {show ? (
          <HiddenEyeFoundation title="Hide password" />
        ) : (
          <EyeFoundation title="Show password" />
        )}
      </span>
      <p aria-live="polite" className={visuallyHidden}>
        {props.show ? 'Password is revealed.' : 'Password is hidden.'}
      </p>
    </ButtonBase>
  );
}
